import { render, staticRenderFns } from "./RecommendedVideos.vue?vue&type=template&id=a31f8c64"
import script from "./RecommendedVideos.vue?vue&type=script&lang=js"
export * from "./RecommendedVideos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports